import { http } from '@/lib/api';
import { LegalDocument } from './types';

function getLegalTerms(): Promise<LegalDocument> {
  return http.get('/api/v1/legal/terms-and-conditions');
}

function getLegalPrivacity(): Promise<LegalDocument> {
  return http.get('/api/v1/legal/privacy-policy');
}

export { getLegalPrivacity, getLegalTerms };
